<template>
  <Article v-for="(item, nr) in itemStore.getItems" :key="item.id" :item="item" :nr="nr"/>
</template>

<script lang="ts" setup>
import Article from "@/components/Article.vue";
import {useItemStore} from "@/itemStore";

const itemStore = useItemStore();
</script>

